import { Component, OnInit,ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-sign-in',
  templateUrl: './SignIn.component.html',
  styleUrls: ['./SignIn.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignInComponent {}
